import axios from "axios"
import store from '../store/index.js'
const options = {
  root: null, //默认浏览器视窗
  threshold: 1 //元素完全出现在浏览器视窗内才执行callback函数。
}

let visuallyList = []
let timer = {}; //增加定时器对象
const callback = entries => {
  entries.forEach(entry => {
    let visuallyData = null;
    try {
      visuallyData = JSON.parse(entry.target.getAttribute('visually-data'));
    } catch (e) {
      visuallyData = null;
      console.error('埋点数据格式异常', e)
    }
    //没有埋点数据取消上报
    if (!visuallyData) {
      observer.unobserve(entry.target)
      return;
    }
    
    if (entry.isIntersecting) {
      timer[visuallyData.productId] = setTimeout(function() {
        // console.log(visuallyData)
        const data = {
           source: 1, // 1:PC 2:小程序
           productId: visuallyData.productId,
           name: visuallyData.productName,
           userCode: store.state.Authorization.username || ''
        }
        // 上报埋点信息
        axios.post('/fbaProductPriceCarrierViewCount/saveFbaProductPriceCarrierViewCount', data).then(res => {
          if (res.success) {
            //上报成功后取消监听
            observer.unobserve(entry.target)
            visuallyList.push(visuallyData.productId)
            timer[visuallyData.productId] = null
          }
        });
      }, 5000);
  } else {
    if (timer[visuallyData.productId]) {
      clearTimeout(timer[visuallyData.productId])
      timer[visuallyData.productId] = null
    }
  }
  });
};
const observer = new IntersectionObserver(callback, options);
const addListenner = (ele, binding) => {
  if(visuallyList.indexOf(binding.value) !== -1) return
  observer.observe(ele)
};
const removeListener = (ele) => {
  observer.unobserve(ele)
}
const visually = {
  bind: addListenner,
  unbind: removeListener,
}
export default visually


// WEBPACK FOOTER //
// ./src/directives/visually.js